import { render, staticRenderFns } from "./ArchiveViewPage.vue?vue&type=template&id=52f52dab"
import script from "./ArchiveViewPage.vue?vue&type=script&lang=js"
export * from "./ArchiveViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports